import React, { useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const location = useLocation();
  const successMessage = location.state?.message || '';

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/login`, {
      email,
      password,
    });
    const { access_token, role } = response.data;
    if (role === 'super_admin' || role === 'town_admin') {
      localStorage.setItem('adminToken', access_token);
      localStorage.setItem('adminRole', role);
      window.location.href = '/admin/dashboard';
    } else {
      localStorage.setItem('token', access_token);
      localStorage.setItem('userEmail', email);
      const params = new URLSearchParams(window.location.search);
      const town = params.get('town');
      const townCode = params.get('town_code');
      const formType = params.get('form_type');
if (town && townCode && formType) {
  if (formType === 'excise_abatement') {
    window.location.href = `/excise-abatement-page2?town=${town}&town_code=${townCode}`;
  } else {
    window.location.href = `/page1?fiscal_year=${new Date().getFullYear()}&town=${town}&town_code=${townCode}&form_type=${formType}`;
  }
} else {
  try {
    const filingsCheck = await axios.get(`${process.env.REACT_APP_API_URL}/filings/my-filings`, {
      headers: { Authorization: `Bearer ${access_token}` },
    });
    if (filingsCheck.data.length === 0) {
      window.location.href = '/';
    } else {
      window.location.href = '/my-filings';
    }
  } catch {
    window.location.href = '/my-filings';
  }
}
    }
  } catch (err) {
    const status = err.response?.status;
    const detail = err.response?.data?.detail;
    if (status === 429) {
      // account lockout (detail) or too many attempts from this computer (rate limit, no detail)
      setError(typeof detail === 'string' ? detail : 'Too many sign-in attempts. Please wait a minute and try again.');
    } else if (status === 400 && typeof detail === 'string') {
      setError(detail); // e.g. deactivated account
    } else {
      setError('Invalid email or password. Please try again.');
    }
  }
};

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>MAtownforms</h1>
        <h2 style={styles.subtitle}>Sign In</h2>
        {successMessage && <p style={styles.success}>{successMessage}</p>}
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button style={styles.button} type="submit">Sign In</button>
          <p style={styles.link}>
  <a href="/forgot-password" style={styles.anchor}>Forgot your password?</a>
</p>
        </form>
        <p style={styles.link}>
          Don't have an account?{' '}
          <a href={`/signup${window.location.search}`} style={styles.anchor}>Create one</a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '420px',
  },
  title: {
  color: '#1a3a5c',
  fontSize: '42px',
  fontWeight: '700',
  fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  marginBottom: '8px',
  textAlign: 'center',
},
  subtitle: {
    color: '#444',
    fontSize: '18px',
    marginBottom: '24px',
    textAlign: 'center',
  },
  field: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '8px',
  },
  error: {
    color: '#cc0000',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  success: {
    color: '#2e7d32',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  link: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '14px',
    color: '#555',
  },
  anchor: {
    color: '#1a3a5c',
    fontWeight: '600',
  },
};

export default Login;